import React from 'react';
import BaseButton, { ButtonProps } from 'antd/es/button';
import './button.scss';

interface Props extends ButtonProps {
  uppercase?: boolean;
  hint?: string;
  hintPosition?: string;
  printButton?: boolean;
  color?: string;
}

const Button: React.FC<Props> = ({
    color,
    uppercase = true,
    className,
    children,
    hint,
    hintPosition,
    printButton,
    icon,
    link,
    ...rest
  }: Props) => {
    return children ? (
      <BaseButton
        className={`button
        ${color ? `button--${color} ` : ''}
        ${uppercase ? 'button--uppercase ' : ''}
        ${printButton ? `button--print-calc ` : ''}
        ${className || ''}
        `}
        icon={icon}
        {...rest}
      >
        {children}
      </BaseButton>
    ) : (
      <BaseButton
        className={`button button--notext
          ${color ? `button--${color} ` : ''}
          ${className || ''}
          `}
        icon={icon}
        {...rest}
      />
    );
  };

  export default Button;
